export class ReassigmentComponentConfig{
  // Configuraciones de la tabla
  settings = {};

  constructor() {
    this.settings = {
      mode: 'external',
      noDataMessage: 'La tarea actual no contiene funcionarios',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        identificacion: {
          editable: false,
          addable: false,
          class: 'prueba',
          title: 'Identificación',
          filter: {
            inputClass: 'form-control',
          },
        },
        nombre: {
          title: 'Nombre',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
        },
        apellidos: {
          title: 'Apellido',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          }
        }
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reassigment-responsibles/shared/reassigment-config.service.ts